module.exports = __webpack_public_path__ + "static/media/status_legend_icon_pH.9e77d3b9.png";